import { render, staticRenderFns } from "./TokenIcon.vue?vue&type=template&id=510794ba&scoped=true&"
import script from "./TokenIcon.vue?vue&type=script&lang=js&"
export * from "./TokenIcon.vue?vue&type=script&lang=js&"
import style0 from "./TokenIcon.vue?vue&type=style&index=0&id=510794ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510794ba",
  null
  
)

export default component.exports